/**
 * Numeric-first sort for internal audit vehicle_code (Araç ID) across tabs.
 */
function compareVehicleCodeStrings(aCode, bCode) {
  const normalize = (v) => String(v ?? '').trim();
  const asNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  const ac = normalize(aCode);
  const bc = normalize(bCode);
  const an = asNum(ac);
  const bn = asNum(bc);
  if (an != null && bn != null) return an - bn;
  if (an != null) return -1;
  if (bn != null) return 1;
  return ac.localeCompare(bc, 'tr', { numeric: true, sensitivity: 'base' });
}

export function compareRowsByVehicleCode(a, b) {
  return compareVehicleCodeStrings(a?.vehicle_code, b?.vehicle_code);
}

export function sortRowsByVehicleCode(rows) {
  return [...(rows || [])].sort(compareRowsByVehicleCode);
}

export function sortVehiclesByVehicleCode(vehicles) {
  return [...(vehicles || [])].sort(compareRowsByVehicleCode);
}
